import store from "@/store";

export default {

  /**
   * @param {string} concept
   * @returns {Promise<*>}
   */
  async invokeLoadOfPresetsFor(concept) {
    if (concept == undefined || store.getters['presetStore/arePresetsLoadedFor'](concept)) { return }
    await store.dispatch('presetStore/loadAndSetPresetsFor', concept);
  },

  /**
   * @param presets
   * @returns {null|*}
   */
  getDefaultPrestOf(presets) {
  if (presets == undefined || presets.length === 0) { return null }
    return presets.find((_preset) => _preset.data.isDefault);
  }
}


